// src/components/AssignTruck.js
import React, { useState, useEffect, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../styles/AssignTrucks.css";
import axios from "../axiosConfig";
import { useTranslation } from "react-i18next";

function AssignTruck() {
  const { t } = useTranslation("assign_truck");

  const [availableTrucks, setAvailableTrucks] = useState([]);
  const [selectedTruckId, setSelectedTruckId] = useState("");
  const { loadId } = useParams();
  const navigate = useNavigate();

  const selectedTruck = useMemo(
    () => availableTrucks.find((truck) => String(truck.id) === String(selectedTruckId)) || null,
    [availableTrucks, selectedTruckId]
  );

  // Fetch available trucks on component mount
  useEffect(() => {
    const fetchTrucks = async () => {
      try {
        const response = await axios.get("/trucks");
        const filteredTrucks = (response.data || []).filter(
          (truck) => String(truck.status).toLowerCase() === "available"
        );
        setAvailableTrucks(filteredTrucks);
      } catch (error) {
        console.error("Error fetching trucks:", error);
      }
    };
    fetchTrucks();
  }, []);

  const handleConfirmAssignment = async () => {
    try {
      await axios.post("/loads/assign-truck", {
        loadId,
        truckId: selectedTruckId
      });

      // 🔊 Broadcast optimistic event so expanded sections patch immediately
      const picked = availableTrucks.find((t) => String(t.id) === String(selectedTruckId));
      window.dispatchEvent(
        new CustomEvent("truck-assigned", {
          detail: {
            scope: "load",
            loadId: Number(loadId),
            truck: { id: Number(selectedTruckId), plate: picked?.plate ?? null }
          }
        })
      );

      alert(t("alerts.success"));
      navigate("/loads");
    } catch (error) {
      console.error("Error assigning truck:", error);
      alert(t("alerts.error"));
    }
  };

  const isConfirmDisabled =
    !selectedTruckId || (selectedTruck && String(selectedTruck.status).toLowerCase() !== "available");

  return (
    <div className="assign-truck-container">
      <h1 className="assign-truck-title">{t("title")}</h1>

      <div className="assign-truck-form">
        <label className="assign-truck-label">{t("labels.selectTruck")}</label>

        <select
          className="assign-truck-select"
          value={selectedTruckId}
          onChange={(e) => setSelectedTruckId(e.target.value)}
        >
          <option value="">{t("placeholders.selectTruck")}</option>
          {availableTrucks.map((truck) => (
            <option key={truck.id} value={truck.id}>
              {t("optionFormat", {
                plate: truck.plate,
                status: truck.status
              })}
            </option>
          ))}
        </select>
      </div>

      <div className="assign-truck-actions">
        <button
          className="assign-truck-confirm-btn"
          onClick={handleConfirmAssignment}
          disabled={isConfirmDisabled}
        >
          {t("buttons.confirm")}
        </button>

        <button className="assign-truck-cancel-btn" onClick={() => navigate("/loads")}>
          {t("buttons.cancel")}
        </button>
      </div>
    </div>
  );
}

export default AssignTruck;
